// import Vue from 'vue/types/vue'
import Vue from 'vue'

const eventbus = new Vue();
eventbus.Events = {
  Signed: 'Signed',
};
export default eventbus;
